/**
 * 统一状态转换工具
 * 用于将状态码转换为中文显示
 */

// ==================== 订单状态 ====================

export const orderStatusMap = {
  'CREATED': '待签约',
  'WAIT_SIGN': '待签约',
  'WAIT_PAY': '待支付',
  'SIGNED': '已签约',
  'SIGN_FAILED': '签约失败',
  'WAIT_APPROVE': '待审核',
  'APPROVED': '待发货',
  'WAIT_CONTRACT': '待合同签署',
  'DELIVERED': '待收货',
  'RECEIVED': '租用中',
  'RENTING': '租用中',
  'RETURN_DELIVERED': '已寄回',
  'RETURN_RECEIVED': '已归还',
  'FINISHED': '已完成',
  'CANCELLED': '已取消',
  'CLOSED': '已关闭',
  'EXPIRED': '已过期',
  'CREATE_FAILED': '创建失败',
  'REFUNDING': '退款中',
  'RETURNING': '退货中'
}

export const orderStatusTypeMap = {
  'CREATED': 'info',
  'WAIT_SIGN': 'info',
  'WAIT_PAY': 'info',
  'SIGNED': 'success',
  'SIGN_FAILED': 'danger',
  'WAIT_APPROVE': 'warning',
  'APPROVED': '',
  'WAIT_CONTRACT': 'warning',
  'DELIVERED': '',
  'RECEIVED': 'success',
  'RENTING': 'primary',
  'RETURN_DELIVERED': 'warning',
  'RETURN_RECEIVED': 'warning',
  'FINISHED': 'success',
  'CANCELLED': 'danger',
  'CLOSED': 'info',
  'EXPIRED': 'info',
  'CREATE_FAILED': 'danger',
  'REFUNDING': 'warning',
  'RETURNING': 'warning'
}

// ==================== 签约状态 ====================

export const signStatusMap = {
  'UNSIGNED': '未签约',
  'SIGNED': '已签约',
  'SIGNING': '签约中',
  'SIGN_FAILED': '签约失败'
}

// ==================== 支付状态 ====================

export const payStatusMap = {
  'UNPAID': '未支付',
  'PAID': '已支付',
  'FAILED': '支付失败',
  'REFUNDED': '已退款',
  'REFUNDING': '退款中',
  'PARTIAL_REFUND': '部分退款',
  'INIT': '初始化',
  'PENDING': '处理中',
  'SUCCESS': '成功',
  'CANCELLED': '已取消',
  'CLOSED': '已关闭'
}

// ==================== 分期状态 ====================

export const installmentStatusMap = {
  'INIT': '待付',
  'UNPAID': '待付',
  'PAID': '已付',
  'REFUNDED': '已退款',
  'OVERDUE': '已逾期'
}

// ==================== 售后类型与状态 ====================

export const aftersaleTypeMap = {
  'RETURN': '退货',
  'REFUND': '退款',
  'COMPENSATION': '赔付'
}

export const aftersaleStatusMap = {
  'PENDING': '待审核',
  'APPROVED': '已通过',
  'REJECTED': '已拒绝',
  'COMPLETED': '已完成',
  'CLOSED': '已关闭'
}

export const aftersaleStatusTypeMap = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'danger',
  COMPLETED: 'success',
  CLOSED: 'info'
}

// ==================== 赔付类型 ====================

export const compensationTypeMap = {
  'DAMAGE': '设备损坏',
  'LOST': '设备丢失',
  'PENALTY': '违约金',
  'OVERDUE': '逾期费用',
  'OTHER': '其他'
}

export const compensationTypeTagMap = {
  DAMAGE: 'warning',
  LOST: 'danger',
  PENALTY: 'info',
  OVERDUE: 'warning',
  OTHER: 'info'
}

// ==================== 支付单状态 ====================

export const paymentStatusMap = {
  'INIT': '初始化',
  'PENDING': '处理中',
  'PAID': '已支付',
  'REFUNDED': '已退款',
  'CANCELLED': '已取消',
  'CLOSED': '已关闭',
  'FAILED': '失败'
}

// ==================== 配送方式 ====================

export const deliveryTypeMap = {
  'EXPRESS': '快递配送',
  'SELF_PICKUP': '自提',
  'SHOP_DELIVERY': '商家配送',
  'SELFPICK': '到店自取',
  'INTRA_CITY_EXPRESS': '同城配送'
}

// ==================== 商品成色 ====================

export const finenessMap = {
  'NEW': '全新',
  'SECOND_HAND': '二手',
  'REFURBISHED': '翻新'
}

// ==================== 合同状态 ====================

export const contractStatusMap = {
  DRAFT: '草稿',
  WAIT_SIGN: '待签署',
  SIGNING: '签署中',
  SIGNED: '已签署',
  CANCELLED: '已取消',
  EXPIRED: '已过期',
  FAILED: '签署失败'
}

export const contractStatusTypeMap = {
  DRAFT: 'info',
  WAIT_SIGN: 'warning',
  SIGNING: 'warning',
  SIGNED: 'success',
  CANCELLED: 'danger',
  EXPIRED: 'info',
  FAILED: 'danger'
}

// ==================== 买断支付状态 ====================

export const buyoutPayStatusMap = {
  UNPAID: '待支付',
  PAID: '已支付',
  CLOSED: '已关闭'
}

export const buyoutPayStatusTypeMap = {
  UNPAID: 'warning',
  PAID: 'success',
  CLOSED: 'info'
}

// ==================== 完结类型 ====================

export const finishTypeMap = {
  NORMAL: '正常到期',
  RETURN: '归还结清',
  BUYOUT: '购买残值结清',
  CANCEL: '取消结清'
}

// ==================== 咨询类型 ====================

export const consultTypeMap = {
  PRE_CHECK: '租前预评估',
  IN_RENT: '租中评估',
  POST_CHECK: '租后评估'
}

export const consultTypeTagMap = {
  PRE_CHECK: '',
  IN_RENT: 'warning',
  POST_CHECK: 'info'
}

// ==================== 支付方式 ====================

export const payMethodMap = {
  'PRE_AUTH': '预授权转支付',
  'SYNC': '线下同步',
  'RENT_DEDUCT': '代扣',
  'JSAPI': 'JSAPI',
  'ALIPAY': '支付宝',
  'WECHAT': '微信',
  'CASH': '现金',
  'OTHER': '其他'
}

// ==================== 租期单位 ====================

export const rentUnitMap = {
  DAY: '按天',
  WEEK: '按周',
  MONTH: '按月'
}

export const rentUnitShortMap = {
  DAY: '天',
  WEEK: '周',
  MONTH: '月'
}

export const rentUnitPriceMap = {
  DAY: '日租金',
  WEEK: '周租金',
  MONTH: '月租金'
}

// ==================== 支付宝状态 ====================

export const alipayStatusMap = {
  CREATED: '已创建',
  INIT: '初始化',
  PENDING: '处理中',
  SUCCESS: '成功',
  FAILED: '失败',
  FAIL: '失败',
  CLOSED: '已关闭',
  WAIT_BUYER_PAY: '等待买家付款',
  TRADE_SUCCESS: '交易成功',
  TRADE_CLOSED: '交易关闭',
  TRADE_FINISHED: '交易完成',
  SIGNED: '已签约',
  UNSIGNED: '未签约',
  SIGNING: '签约中',
  SIGN_FAILED: '签约失败'
}

// ==================== 通用函数 ====================

/**
 * 通用状态转换函数
 * @param {string} status 状态码
 * @param {object} map 状态映射表
 * @param {string} defaultValue 默认值
 * @returns {string} 中文状态
 */
export function getStatusText(status, map, defaultValue = '未知') {
  if (!status) return defaultValue
  return status in map ? map[status] : (status || defaultValue)
}

// ---------- 订单 ----------
export function getOrderStatusText(status) {
  return getStatusText(status, orderStatusMap)
}

// ---------- 签约 ----------
export function getSignStatusText(status) {
  return getStatusText(status, signStatusMap)
}

// ---------- 支付 ----------
export function getPayStatusText(status) {
  return getStatusText(status, payStatusMap)
}

// ---------- 分期 ----------
export function getInstallmentStatusText(status) {
  return getStatusText(status, installmentStatusMap)
}

export function getInstallmentStatusTag(status) {
  if (status === 'PAID') return 'success'
  if (status === 'REFUNDED') return 'info'
  if (status === 'OVERDUE') return 'danger'
  return 'warning'
}

// ---------- 售后 ----------
export function getAftersaleTypeText(type) {
  return getStatusText(type, aftersaleTypeMap)
}

export function getAftersaleStatusText(status) {
  return getStatusText(status, aftersaleStatusMap)
}

export function getAftersaleStatusType(status) {
  return getStatusText(status, aftersaleStatusTypeMap, 'info')
}

// ---------- 赔付 ----------
export function getCompensationTypeText(type) {
  return getStatusText(type, compensationTypeMap)
}

export function getCompensationTypeTag(type) {
  return getStatusText(type, compensationTypeTagMap, 'info')
}

// ---------- 支付单 ----------
export function getPaymentStatusText(status) {
  return getStatusText(status, paymentStatusMap)
}

export function getPaymentStatusTag(status) {
  if (status === 'PAID') return 'success'
  if (status === 'INIT') return 'info'
  if (status === 'PENDING') return 'warning'
  if (status === 'CLOSED' || status === 'FAILED') return 'danger'
  return 'info'
}

// ---------- 配送 ----------
export function getDeliveryTypeText(type) {
  return getStatusText(type, deliveryTypeMap)
}

// ---------- 成色 ----------
export function getFinenessText(fineness) {
  return getStatusText(fineness, finenessMap)
}

// ---------- 合同 ----------
export function getContractStatusText(status) {
  return getStatusText(status, contractStatusMap, '-')
}

export function getContractStatusTag(status) {
  return getStatusText(status, contractStatusTypeMap, 'info')
}

// ---------- 买断支付 ----------
export function getBuyoutPayStatusText(status) {
  return getStatusText(status, buyoutPayStatusMap, '-')
}

export function getBuyoutPayStatusTag(status) {
  return getStatusText(status, buyoutPayStatusTypeMap, 'info')
}

// ---------- 完结类型 ----------
export function getFinishTypeText(type) {
  return getStatusText(type, finishTypeMap, '-')
}

// ---------- 咨询类型 ----------
export function getConsultTypeText(type) {
  return getStatusText(type, consultTypeMap, '-')
}

export function getConsultTypeTag(type) {
  return getStatusText(type, consultTypeTagMap, 'info')
}

// ---------- 支付方式 ----------
export function getPayMethodText(method) {
  return getStatusText(method, payMethodMap, method || '-')
}

export function getPayMethodTag(method) {
  if (method === 'PRE_AUTH') return 'primary'
  if (method === 'SYNC') return 'warning'
  if (method === 'RENT_DEDUCT') return 'danger'
  return 'info'
}

// ---------- 租期单位 ----------
export function getRentUnitText(unit) {
  return getStatusText(unit, rentUnitMap, '-')
}

export function getRentUnitShortText(unit) {
  return getStatusText(unit, rentUnitShortMap, '')
}

export function getRentUnitPriceText(unit) {
  return getStatusText(unit, rentUnitPriceMap, '单位租金')
}

// ---------- 支付宝 ----------
export function getAlipayStatusText(status) {
  return getStatusText(status, alipayStatusMap, '-')
}

// ---------- 赔付单支付状态（售后相关） ----------
export const payStatusForAftersaleMap = {
  UNPAID: '待支付',
  PAID: '已支付',
  FAILED: '支付失败'
}

export const payStatusForAftersaleTypeMap = {
  UNPAID: 'warning',
  PAID: 'success',
  FAILED: 'danger'
}

export function getPayStatusForAftersaleText(status) {
  return getStatusText(status, payStatusForAftersaleMap, '-')
}

export function getPayStatusForAftersaleType(status) {
  return getStatusText(status, payStatusForAftersaleTypeMap, 'info')
}

// ==================== 管理员角色类型 ====================

export const roleTypeMap = {
  'SYSTEM_ADMIN': '系统管理员',
  'SERVICE_PROVIDER': '服务商管理员',
  'PLATFORM': '小程序管理员'
}

export const roleTypeTagMap = {
  'SYSTEM_ADMIN': 'danger',
  'SERVICE_PROVIDER': 'primary',
  'PLATFORM': 'info'
}


// ==================== 风控模型类型 ====================

export const riskTypeMap = {
  CONCURRENT_RENT: '共租风险',
  COMPREHENSIVE_RISK: '综合风险',
  SHIP_GOODS_RISK: '发货风险',
  VERTICAL_RENT_RISK: '租赁专项'
}
